import { Suspense } from 'react'

import { SavingsSkeleton } from './components/skeleton/SavingsSkeleton'
import { useSavings } from './logic/useSavings'
import { SavingsView } from './views/SavingsView'
import { getChainConfigEntry } from '@/config/chain'
import { usePageChainId } from '@/domain/hooks/usePageChainId'
import { useConnectModal } from '@/domain/hooks/wallet'
import { useSandbox } from '@/domain/sandbox/useSandbox'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'

function SavingsContainer() {
  const savings = useSavings()
  const isGuestMode = useConnectedAddress({ throwOnNotConnected: false }).account === undefined
  const { openConnectModal = () => {} } = useConnectModal()
  const { openSandboxModal } = useSandbox()

  return (
    <SavingsView
      {...savings}
      guestMode={isGuestMode}
      openSandboxModal={openSandboxModal}
      openConnectModal={openConnectModal}
    />
  )
}

function SavingsContainerWithSuspense() {
  const { chainId } = usePageChainId()
  const chainConfig = getChainConfigEntry(chainId)

  const numberOfAccounts = chainConfig.savings?.accounts?.length ?? 0

  return (
    <Suspense fallback={<SavingsSkeleton numberOfAccounts={numberOfAccounts} />}>
      <SavingsContainer />
    </Suspense>
  )
}
export { SavingsContainerWithSuspense as SavingsContainer }
